<template>
  <v-col cols="12">
    <v-col class="col-sm-12 col-xs-12">
      <v-card color="white" dark class="rounded-xl" flat>
        <v-card-title class="text-h5" style="color: #6b6868"> </v-card-title>

        <v-card-subtitle>
          <v-alert
            outlined
            type="success"
            prominent
            border="left"
            text
            style="margin-top: 1em"
            v-if="personalInfosIsUpdated === true"
          >
            Vos informations personnelles ont bien été mises à jour.
          </v-alert>
          <v-alert
            outlined
            type="error"
            prominent
            border="left"
            style="margin-top: 1em"
            v-if="formErrors.length > 0"
          >
            <b>Veuillez corriger les erreurs suivantes:</b>
            <ul>
              <li v-for="(error, index) in formErrors" :key="index">
                • {{ error }}
              </li>
            </ul>
          </v-alert>
          <section
            style="
              background: rgba(255, 255, 255, 0.9);
              color: #777171;
              padding: 1em;
            "
          >
            <v-form>
              <v-row>
                <v-col cols="12" style="margin-top: -1.5em">
                  <v-select
                    :items="selectItems"
                    v-model="formFields.gender"
                    label="Genre"
                    prepend-inner-icon="mdi-gender-male-female"
                    light
                  ></v-select>
                </v-col>
                <v-col cols="12" md="12" style="margin-top: -2em">
                  <v-text-field
                    label="Email"
                    placeholder="Ex: exemple@exemple.fr"
                    v-model="formFields.email"
                    prepend-inner-icon="mdi-at"
                    disabled
                    light
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-text-field
                    label="Nom"
                    v-model="formFields.lastname"
                    placeholder="Ex: SACKO"
                    prepend-inner-icon="mdi-card-account-details-outline"
                    light
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-text-field
                    label="Prénoms"
                    v-model="formFields.firstname"
                    placeholder="Ex: Mohamed Kounda"
                    prepend-inner-icon="mdi-card-account-details"
                    light
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="formFields.birthdate"
                        label="Date de naissance"
                        light
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="formFields.birthdate"
                      :active-picker.sync="activePicker"
                      :max="birthDateMax"
                      :min="birthDateMin"
                      @change="save"
                      locale="fr-fr"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-text-field
                    label="Numéro de téléphone"
                    v-model="formFields.phoneNumber"
                    placeholder="Ex: 624 99 99 99"
                    prepend-inner-icon="mdi-cellphone-sound"
                    light
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-textarea
                    label="Adresse"
                    v-model="formFields.adresse"
                    placeholder="Ratoma, près de l'hôpital"
                    persistent-placeholder
                    prepend-inner-icon="mdi-office-building-marker-outline"
                    light
                    rows="1"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-textarea
                    label="A propos de moi "
                    persistent-placeholder
                    placeholder="Bonjour! Je suis Moussa Bangoura. Je suis passionné par le design UI/UX et le Web Design. Je suis un développeur front-end qualifié et maîtrise les outils de conception graphique tels que Photoshop et Sketch."
                    v-model="formFields.aboutMe"
                    prepend-inner-icon="mdi-office-building-marker-outline"
                    light
                    rows="2"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-text-field
                    label="Titre du cv"
                    v-model="formFields.cvTitle"
                    placeholder="Ex: Graphic Designer & Web Developer"
                    prepend-inner-icon="mdi-cellphone-sound"
                    light
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" offset-md="4" md="4" sm="12" xs="12">
                  <v-btn
                    class="col-12"
                    color="primary"
                    @click="updateUserInfos"
                  >
                    Enregistrer et continuer
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </section>
        </v-card-subtitle>
      </v-card>
    </v-col>
  </v-col>
</template>

<script>
import Vue from "vue";
import HttpClient from "@/services/HttpClient/HttpClient";

export default Vue.extend({
  name: "CvGeneratorPersonalInformationForm",
  props: {
    informationsNextStepCallBack: Function,
  },
  data: function () {
    return {
      currentSeeker: null,
      personalInfosIsUpdated: false,
      selectItems: ["Femme", "Homme"],
      birthDateMin: null,
      birthDateMax: null,
      activePicker: null,
      formFields: {
        gender: null,
        firstname: null,
        lastname: null,
        birthdate: null,
        phoneNumber: null,
        adresse: null,
        cvTitle: null,
        aboutMe: null,
        email: null,
      },
      date: null,
      currentUserInfos: {},
      menu: false,
      show1: false,
      formErrors: [],
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
    },
    checkForm: function () {
      this.formErrors = [];
      let isValid = true;

      if (
        !this.formFields.firstname ||
        this.formFields.firstname.trim() === ""
      ) {
        isValid = false;
        this.formErrors.push("Le prénom est obligatoire.");
      }

      if (!this.formFields.lastname || this.formFields.lastname.trim() === "") {
        isValid = false;
        this.formErrors.push("Le nom est obligatoire.");
      }

      if (!this.formFields.cvTitle) {
        isValid = false;
        this.formErrors.push("le titre du cv est obligatoire.");
      }

      if (
        !this.formFields.phoneNumber ||
        this.formFields.phoneNumber.trim() === ""
      ) {
        isValid = false;
        this.formErrors.push("Votre numéro de téléphone est obligatoire.");
      }

      if (!this.formFields.gender || this.formFields.gender.trim() === "") {
        isValid = false;
        this.formErrors.push("Votre civilité est obligatoire.");
      } else if (
        this.formFields.gender !== "Homme" &&
        this.formFields.gender !== "Femme"
      ) {
        isValid = false;
        this.formErrors.push("Votre civilité est incorrecte.");
      }

      return isValid;
    },
    updateUserInfos: async function () {
      if (this.checkForm()) {
        const httpClient = new HttpClient();
        await httpClient
          .updateUserInformations(
            {
              firstname: this.formFields.firstname,
              lastname: this.formFields.lastname,
              gender: this.formFields.gender,
              id: this.currentUserInfos.id,
              birthday: this.formFields.birthdate,
              phoneNumber: this.formFields.phoneNumber,
            },
            localStorage.getItem("jwt-token")
          )
          .then(async (value) => {
            let tmpSeeker = {
              id: this.currentSeeker.id,
              isPersonalInformationsFilled: true,
              cvTitle: this.formFields.cvTitle,
            };

            if (this.formFields.adresse !== null) {
              tmpSeeker["adresse"] = this.formFields.adresse;
            }

            if (this.formFields.aboutMe !== null) {
              tmpSeeker["profileDescription"] = this.formFields.aboutMe;
              tmpSeeker["isProfileDescriptionInformationsFilled"] = true;
            }

            await httpClient
              .updateSeekerInformations(
                tmpSeeker,
                localStorage.getItem("jwt-token")
              )
              .then((res) => {
                this.currentSeeker = res.data;
                console.log(res.data);
                this.informationsNextStepCallBack(3);
              })
              .catch((reason) => {
                if (reason.response.status === 401) {
                  this.$router.push("/logout");
                }

                alert("Une erreur s'est produite");
                console.error(reason);
              });
          })
          .catch((reason) => {
            if (reason.response.status === 401) {
              this.$router.push("/logout");
            }
            this.formErrors = [];
            this.formErrors.push("Une erreur s'est produite");
          });
      }
    },
  },
  created() {
    const httpClient = new HttpClient();
    httpClient
      .getCurrentUserInformations(localStorage.getItem("jwt-token"))
      .then((value) => {
        this.currentUserInfos = value.data;
        this.formFields.birthdate =
          value.data.birthday === null
            ? null
            : value.data.birthday.toLocaleString().split("T")[0];
        this.formFields.lastname = value.data.lastname;
        this.formFields.firstname = value.data.firstname;
        this.formFields.gender = value.data.gender;
        this.formFields.phoneNumber = value.data.phoneNumber;
        this.formFields.email = value.data.email;
        this.formFields.cvTitle = value.data.seeker.cvTitle;

        httpClient
          .getCurrentSeeker(localStorage.getItem("jwt-token"))
          .then((res) => {
            console.log(res.data);
            this.currentSeeker = res.data;
            this.formFields.aboutMe = this.currentSeeker.profileDescription;
            this.formFields.adresse = this.currentSeeker.adresse;
          })
          .catch((error) => {
            console.log(error);
            if (error.response.status === 401) {
              this.$router.push("/logout");
            }
          });
      })
      .catch((error) => {
        console.log(error);
        if (error.response.status === 401) {
          this.$router.push("/logout");
        }
      });

    const currentDate = new Date();
    this.birthDateMax = `${currentDate.getFullYear() - 18}-12-31`;
    this.birthDateMin = `${currentDate.getFullYear() - 80}-01-01`;
  },
});
</script>

<style scoped></style>
